import { useState, useEffect } from 'react';
import { getJobs, createJob, updateJob, deleteJob } from '../../services/admin/jobService';
import type { Job } from '../../types/job';

export function useJobs() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [applications, setApplications] = useState<any[]>([]);

  const loadJobs = async () => {
    setIsLoading(true);
    try {
      const data = await getJobs();
      setJobs(data);
    } catch (error) {
      console.error('Error loading jobs:', error);
      toast.error('Failed to load jobs');
      setJobs([]);
    } finally {
      setIsLoading(false);
    }
  };

  const loadJobApplications = async (jobId: string) => {
    try {
      const data = await getJobApplications(jobId);
      setApplications(data);
    } catch (error) {
      console.error('Error loading job applications:', error);
    }
  };

  useEffect(() => {
    loadJobs();
  }, []);

  useEffect(() => {
    if (selectedJob) {
      loadJobApplications(selectedJob.id);
    }
  }, [selectedJob]);

  const handleCreateJob = async (jobData: Omit<Job, 'id' | 'postedAt'>) => {
    const newJob = await createJob(jobData);
    await loadJobs();
    return newJob;
  };

  const handleUpdateJob = async (jobId: string, jobData: Partial<Job>) => {
    const updatedJob = await updateJob(jobId, jobData);
    await loadJobs();
    return updatedJob;
  };

  const handleDeleteJob = async (jobId: string) => {
    await deleteJob(jobId);
    await loadJobs();
  };

  return {
    jobs,
    isLoading,
    selectedJob,
    setSelectedJob,
    applications,
    createJob: handleCreateJob,
    updateJob: handleUpdateJob,
    deleteJob: handleDeleteJob,
    refreshJobs: loadJobs
  };
}